import { IApplicationContext } from 'shared/context/applicationContext/types';
import { TBrowserStore } from '../../../shared/types/store';

export function createApplicationState(context: IApplicationContext): TBrowserStore {
  const { config } = context;

  return config.getStrict<TBrowserStore>('initialState');
}
